<template>
  <div style="height: 100%;overflow: auto;" v-loading="isLoading">
    <div class="quote">
      {{ serviceName }}
      <el-button size="mini" @click="back" style="position: absolute;right: 50px;" round>返回</el-button>
      <el-button type="primary" size="mini" @click="submit" style="position: absolute;right: 130px;" round>保存
      </el-button>
    </div>
    <mavon-editor
      ref="editor"
      :style="{height: pageHeight - 62 + 'px'}"
      codeStyle="androidstudio"
      @save="submit"
      @imgAdd="uploadImg"
      @imgDel="deleteImg"
      v-model="formData.document">
    </mavon-editor>
  </div>
</template>

<script>
  import util from '@/libs/util'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  export default {
    name: 'service-document-edit',
    data() {
      return {
        formData: {
          serviceId: this.$route.query.parentId,
          document: ''
        },
        serviceName: null,
        isLoading: false,
        pageHeight: 800,
        timer: null
      }
    },
    mounted() {
      this.getDocument()
      this.$nextTick(this.update)
      addResizeListener(this.$el, this.update)
    },
    beforeDestroy() {
      removeResizeListener(this.$el, this.update)
    },
    methods: {
      update() {
        // 设置el-scrollbar中内层div高度与最外层高度一致
        this.pageHeight = this.$el.offsetHeight
      },
      getDocument: function () {
        this.isLoading = true
        util.ajax.get('/entity/dev/apiServiceDetail/document/' + this.formData.serviceId).then(res => {
          this.isLoading = false
          if (res.data.meta.errCode === 0) {
            this.$set(this.formData, 'document', res.data.data.document)
            this.serviceName = res.data.data.serviceName
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
          }
        }).catch(err => {
          this.isLoading = false
          console.warn(err)
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      },
      submit: function () {
        if (this.formData.document === null || this.formData.document.trim() === '') {
          this.$notify.warning({title: '警告', message: '文档内容不得为空'})
          return
        }
        this.isLoading = true
        this.uploadDocument(false)
      },
      uploadDocument: function (auto) {
        util.ajax.post('/entity/dev/apiServiceDetail/document', {
          params: this.formData
        }).then(res => {
          this.isLoading = false
          if (res.data.meta.errCode === 0) {
            if (auto) {
              this.$message.success('自动保存成功')
            } else {
              this.$notify.success({title: '成功', message: res.data.meta.errMsg})
            }
          } else {
            if (auto) {
              this.$message.error('自动保存失败，' + res.data.meta.errMsg)
            } else {
              this.$notify.warning({title: '失败', message: res.data.meta.errMsg})
            }
          }
        }).catch(err => {
          this.isLoading = false
          console.error(err)
          if (auto) {
            this.$message.error('自动保存失败，系统错误')
          } else {
            this.$notify.error({title: '错误', message: '系统错误'})
          }
        })
      },
      back: function () {
        this.$confirm('您是否要放弃当前编辑内容？', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          util.routerBack(this)
        }).catch()
      },
      uploadImg: function (fileName, file) {
        let formData = new FormData()
        formData.append('image', file)
        util.ajax.post('/entity/dev/apiServiceDetail/image', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
          if (res.data.meta.errCode === 0) {
            this.$refs.editor.$img2Url(fileName, res.data.data.url)
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      },
      deleteImg: function (fileName) {
        util.ajax.delete('/entity/dev/apiServiceDetail/image', {
          params: {
            url: fileName
          }
        }).then(res => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: res.data.meta.errMsg})
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
          }
        }).catch(err => {
          console.error(err)
          this.$notify.error({title: '错误', message: '系统错误'})
        })
      }
    }
  }
</script>

<style scoped>
  .quote {
    margin-bottom: 10px;
    padding: 15px;
    line-height: 22px;
    border-radius: 0 2px 2px 0;
    background-color: #f2f2f2;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/grid/service/service-document-edit.vue